export default function Checkbox(theme) {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    "color": theme.palette.grey[300],
                    "padding": 0,
                    '&:hover': {
                        color: theme.palette.borderColor,
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: `0px 0px 0px 4px ${theme.palette.focusColor}`,
                    },
                    '&.Mui-checked': {
                        '&:hover': {
                            color: theme.palette.primary.main,
                            borderRadius: theme.shape.borderRadius,
                            boxShadow: `0px 0px 0px 4px ${theme.palette.focusColor}`,
                        },
                    },
                },
            },
        },
    };
}
